import {
  ShieldCheckIcon,
  FaceSmileIcon,
  UsersIcon,
  ChartBarIcon,
  AdjustmentsHorizontalIcon,
} from '@heroicons/react/24/outline'
import APP_CONFIG from 'constants/clientConfigs'

const {siteName, bgColor} = APP_CONFIG[process.env.REACT_APP_CLIENT_ID]

const features = [
  {
    name: 'Partnering with an Industry Leader:',
    description: `With over 20 years of experience, ${siteName} has grown a massive and loyal audience that keeps returning to find new deals.`,
    href: '#',
    icon: ShieldCheckIcon,
  },
  {
    name: 'New Customer Acquisition',
    description:
      'Coupons targeting new shoppers are a strong channel for growing your brand’s new customer base.',
    href: '#',
    icon: UsersIcon,
  },
  {
    name: 'Increase in Sales and Conversion Rates',
    description:
      'Increase your sales, conversion rates, and loyal customer base by offering coupons, promo codes, and deals.',
    href: '#',
    icon: ChartBarIcon,
  },

  {
    name: 'Increase in Average Order Size',
    description:
      'Promo codes and coupons with strategic order value targets can provide increases to overall average order value.',
    href: '#',
    icon: AdjustmentsHorizontalIcon,
  },

  {
    name: 'Positive Brand Experience',
    description:
      'Offering coupons is crucial for retailers in today’s consumer environment. ​Research shows strong coupons can cultivate positive emotions in shoppers toward your brand and benefit the overall purchase cycle.',
    href: '#',
    icon: FaceSmileIcon,
  },
]

export default function FeatureList() {
  return (
    <div className="bg-white py-12 sm:py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            What is the value of a coupon promotion advertisement on {siteName}?
          </h2>
          <p className="mt-6 text-lg/8 text-gray-600">
            {siteName} delivers more than discounts—we deliver value.
          </p>
        </div>
        <div className="mx-auto mt-8 max-w-2xl sm:mt-12 lg:mt-12 lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
            {features.map(feature => (
              <div key={feature.name} className="flex flex-col">
                <dt className="text-base/7 font-semibold text-gray-900">
                  <div
                    className={`mb-6 flex items-center justify-center rounded-lg ${bgColor} h-16 w-16`}>
                    <feature.icon
                      aria-hidden="true"
                      className="text-white h-12 w-12"
                    />
                  </div>
                  {feature.name}
                </dt>
                <dd className="mt-1 flex flex-auto flex-col text-base/7 text-gray-600">
                  <p className="flex-auto">{feature.description}</p>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}
